module.exports = __webpack_public_path__ + "img/0. mlogin.4bb1dcf9.jpg";